import styled from "styled-components";

export default c => styled(c)`
  .text-field--element {
    height: 200px;
  }

  .template-info {
    padding-top: 18px;

    code {
      white-space: normal;
      color: #d72b3f;
      padding: 2px 3px;
      background-color: #f7f7f9;
      border: 1px solid #e1e1e8;
      border-radius: 5px;
      font-family: monospace;
    }

    dd {
      margin-top: 4px;
      margin-bottom: 8px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/config-app/email-config/style.js